module.exports = __webpack_public_path__ + "static/img/sg2.635db4d.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/role3/control2/sg2.png
// module id = cMKR
// module chunks = 7